import { Buffer } from "buffer";
import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import * as serviceworker from './serviceWorker';
import App from "./App";

window.Buffer = Buffer;

const isResizeObserverLoopError = (message = "") => (
	message.includes("ResizeObserver loop completed with undelivered notifications") ||
	message.includes("ResizeObserver loop limit exceeded")
);

window.addEventListener("error", (event) => {
	if (isResizeObserverLoopError(event.message)) {
		event.stopImmediatePropagation();
	}
});

window.addEventListener("unhandledrejection", (event) => {
	const message = event.reason?.message || String(event.reason || "");
	if (isResizeObserverLoopError(message)) {
		event.preventDefault();
	}
});

ReactDOM.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
	document.getElementById("root"),
	() => {
		// Verifica se a função existe antes de chamar para evitar erros
		if (typeof window.finishProgress === 'function') {
			window.finishProgress();
		}
	}
);

serviceworker.register();
